/*
 * @File
 * @Author Ngatia Frankline <fngatia@gmail.com>
 * @Created 2/7/23, 12:54 AM.
 * @Bincrud Copyright (c) 2023 All rights reserved.
 */

/**
 * Init swiper slider with 1 slide at once in desktop view
 */

import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  "use strict";


  const swiper = new Swiper('.testimony-slides', {
    speed: 600,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

})